import { memo, MouseEvent, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  actions?: ReactNode
  additional?: ReactNode
  children?: ReactNode
  className?: string
  footer?: ReactNode
  header?: ReactNode
  headerClassName?: string
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  stacked?: boolean
  testId?: string
}

export const ListCard = memo<IProps>(function ListCard({
  header,
  additional,
  actions,
  className,
  headerClassName,
  children,
  footer,
  stacked = true,
  testId,
  ...props
}) {
  return (
    <div
      {...props}
      data-test-id={testId}
      className={cn('grid gap-2 bg-surface p-4', 'max-md:gap-4 max-md:py-3', className, {
        'peer:border-t peer:border-t-on-surface/[.20]': stacked
      })}
    >
      {(header || actions) && (
        <div
          className={cn(
            'grid grid-cols-[auto_min-content] gap-2',
            'md:pb-2',
            'max-sm:pb-0',
            'max-md:font-medium',
            'max-2md:font-bold',
            headerClassName
          )}
        >
          {header && <div className="flex flex-1 items-center self-center">{header}</div>}
          {(additional || actions) && (
            <div className="relative flex items-center justify-self-end">
              {additional && <div className="flex items-center">{additional}</div>}
              {actions && (
                <div
                  className={cn('-mr-8', {
                    'ml-16': !!additional
                  })}
                >
                  {actions}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div>{children}</div>
      {footer && <div>{footer}</div>}
    </div>
  )
})
